import { type TLShapeInfo, defaultShapes } from '@tldraw/tldraw'
import { CustomFrameShape } from './CustomFrameShapeUtil'
import { CustomImageShape } from './CustomImageShapeUtil'

export const shapes: Array<TLShapeInfo<any>> = [
	...defaultShapes,
	CustomFrameShape,
	CustomImageShape,
]
